import React from 'react';
import { Link } from 'react-router';
import { legalPageUrl, isAbsoluteLegalUrl } from '../legal/legalLinks';

const LegalFooter: React.FC = () => {
  const termsUrl = legalPageUrl('terms');
  const privacyUrl = legalPageUrl('privacy');
  const year = new Date().getFullYear();

  const renderLink = (label: string, url: string, testId: string) => {
    if (isAbsoluteLegalUrl(url)) {
      return (
        <a
          href={url}
          className="hover:text-primary-500 dark:hover:text-primary-300 transition-colors"
          data-testid={testId}
        >
          {label}
        </a>
      );
    }
    return (
      <Link
        to={url}
        className="hover:text-primary-500 dark:hover:text-primary-300 transition-colors"
        data-testid={testId}
      >
        {label}
      </Link>
    );
  };

  return (
    <footer
      className="border-t border-secondary-200 dark:border-secondary-700 py-6 mt-auto"
      data-testid="legal-footer"
    >
      <div className="container mx-auto px-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-secondary-500 dark:text-secondary-400">
        {renderLink('Terms', termsUrl, 'legal-footer-terms-link')}
        <span aria-hidden className="text-secondary-300 dark:text-secondary-600">
          ·
        </span>
        {renderLink('Privacy', privacyUrl, 'legal-footer-privacy-link')}
        <span aria-hidden className="text-secondary-300 dark:text-secondary-600">
          ·
        </span>
        <span className="text-secondary-400 dark:text-secondary-500">
          © {year} Scoutlytics
        </span>
      </div>
    </footer>
  );
};

export default LegalFooter;
